import Degen from '../assets/team/degen.png'
import CodeStag from '../assets/team/codestag.png'
import Surveyor from '../assets/team/Surveyor.jpg'
import { motion } from "framer-motion";

const Team = () => {

    const animation = (delay, xStart, xEnd, yStart, yEnd) => {
        const result = {
            initial: { opacity: 0, x: xStart, y: yStart },
            whileInView: { opacity: 1, x: xEnd, y: yEnd },
            viewport: { once: true },
            transition: {
                ease: "easeInOut",
                duration: 0.6,
                delay: delay,
            }
        }
        return result;
    }

    const team = [
        {
            name: 'DegeNik',
            position: 'COO',
            desc: "DegeNik has 20 years of experience in IT, development, and strategy, from startups to Fortune 100 firms. A DeFi veteran since 2021, he led DeFi Raiders, hosting AMAs with projects from tomb forks to blue chips like Synthetix and Lyra. He also owns thousands of worthless NFTs.",
            img: Degen,
            link: 'https://x.com/ThingsDegen'
        },
        {
            name: 'Shitcoin Surveyor',
            position: 'CEO',
            desc: 'Shitcoin Surveyor, a land surveyor turned crypto veteran since 2017, merges precision with blockchain innovation. As the creator of $MOIST and co-creator of $RAP with SurveyorDAO, he\'s helped shape token economies and governance. Now, he brings his expertise as a co-founder of MondrianSwap.',
            img: Surveyor,
            link: 'https://x.com/CoinSurveyor'
        },
        {
            name: 'CodeStag Labs',
            position: 'Design and Development team',
            desc: 'CodeStag is the product of a dynamic partnership between a Full-Stack Developer and a Front-End/UI/UX Designer.',
            img: CodeStag,
            link: 'https://codestag.xyz/'
        },
    ]


    return (
        <>


            <div className='px-[5%] flex mt-[35%] flex-col'>
                <div className='flex flex-col items-center justify-center'>
                    <motion.div {...animation(0.4, 0, 0, -50, 0)} className='text-8xl xl:text-6xl uppercase font-bold mb-10 text-center'>our team</motion.div>
                    <motion.div {...animation(0.4, 0, 0, 50, 0)} className='desc text-center text-2xl w-1/2'>An equal partnership of four experienced DeFi operators, we're here to build and to grow DeFi on Abstract.</motion.div>
                </div>

                <div className="flex flex-wrap justify-between pl-[5%] gap-6 mt-14 lg:flex-col">
                    {team.map((el, i) => (
                        <motion.div {...animation(0.4, 0, 0, 0, 0)} className='flex flex-col md:items-center min-h-[180px] w-[40%] xl:w-[48%] md:w-full items-center justify-start gap-6'>
                            <div className='min-w-[170px]'>
                                <img src={el.img} className='object-cover w-[170px] team_avatar' />
                            </div>
                            <div className='flex flex-col gap-4 flex-1 md:items-center md:text-center'>
                                <a 
                                    href={el.link} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    className='font-[Plus Jakarta Sans] text-lg font-normal hover:text-green-300 transition-colors duration-300'
                                >
                                    {el.name}
                                </a>
                                <div className='font-[Plus Jakarta Sans] text-sm text-[#8B99A3] font-normal'>{el.position}</div>
                                <div className='font-[Plus Jakarta Sans] xl:text-xs text-sm font-normal'>{el.desc}</div>
                            </div>
                        </motion.div>
                    ))}

                </div>

            </div>
        </>
    );
};
export default Team;
